import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import styles from "./Banner.module.css";

export type BannerTone = "info" | "warn" | "success";

export type BannerProps = {
  tone?: BannerTone;
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const Banner = ({
  tone = "info",
  title,
  actions,
  className,
  children,
  ...rest
}: BannerProps) => (
  <div data-tone={tone} className={cx(styles.banner, className)} {...rest}>
    <div className={styles.body}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.message}>{children}</div>
    </div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </div>
);
